import {MarketingEventTypeEnum} from "./MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum, MarketingEventVariableNameById} from "./MarketingEventVariableTypeEnum";

// Список доступных параметров для каждого события
/**
 * @see common/enums/bi/EventTypeEnum.php
 * @see common/enums/bi/EventVariableTypeEnum.php
 * */
export const MarketingEventAllowedVariables = {
    [MarketingEventTypeEnum.addToCart]: [
        MarketingEventVariableTypeEnum.marketingProductId,    // item_id
        MarketingEventVariableTypeEnum.productName,   // item_name
        MarketingEventVariableTypeEnum.productPrice,  // price
        MarketingEventVariableTypeEnum.quantity,      // quantity
        MarketingEventVariableTypeEnum.currency,      // currency
        MarketingEventVariableTypeEnum.value          // value
    ],
    [MarketingEventTypeEnum.viewProductCard]: [
        MarketingEventVariableTypeEnum.marketingProductId,        // item_id
        MarketingEventVariableTypeEnum.productName,        // item_name
        MarketingEventVariableTypeEnum.productPrice,       // price
        MarketingEventVariableTypeEnum.currency,           // currency
        MarketingEventVariableTypeEnum.productBrand,       // item_brand
        MarketingEventVariableTypeEnum.productCategory     // item_category
    ],
    [MarketingEventTypeEnum.removeFromCart]: [
        MarketingEventVariableTypeEnum.marketingProductId,     // item_id
        MarketingEventVariableTypeEnum.productPrice,   // price
        MarketingEventVariableTypeEnum.quantity,       // quantity
        MarketingEventVariableTypeEnum.currency,       // currency
        MarketingEventVariableTypeEnum.value,          // value
        MarketingEventVariableTypeEnum.revenue,        // revenue
        MarketingEventVariableTypeEnum.productName     // productName
    ],
    [MarketingEventTypeEnum.beginCheckout]: [
        MarketingEventVariableTypeEnum.items,     // items[]
        MarketingEventVariableTypeEnum.currency,  // currency
        MarketingEventVariableTypeEnum.value,      // value
        MarketingEventVariableTypeEnum.revenue    // revenue
    ],
    [MarketingEventTypeEnum.addPaymentInfo]: [
        MarketingEventVariableTypeEnum.paymentType,   // payment_type
        MarketingEventVariableTypeEnum.items,         // items[]
        MarketingEventVariableTypeEnum.currency,      // currency
        MarketingEventVariableTypeEnum.value,          // value
         MarketingEventVariableTypeEnum.revenue,
    ],
    [MarketingEventTypeEnum.purchase]: [
        MarketingEventVariableTypeEnum.transactionId, // transaction_id
        MarketingEventVariableTypeEnum.affiliation,   // affiliation
        MarketingEventVariableTypeEnum.value,         // value
        MarketingEventVariableTypeEnum.currency,      // currency
        MarketingEventVariableTypeEnum.tax,           // tax
        MarketingEventVariableTypeEnum.shipping,      // shipping
        MarketingEventVariableTypeEnum.items          // items[]
    ],
    [MarketingEventTypeEnum.call]: [
        MarketingEventVariableTypeEnum.eventCategory, // event_category
        MarketingEventVariableTypeEnum.eventLabel,    // event_label
        MarketingEventVariableTypeEnum.value          // value
    ],
    [MarketingEventTypeEnum.viewItemList]: [
        MarketingEventVariableTypeEnum.productCategory,
        MarketingEventVariableTypeEnum.items
    ],
    [MarketingEventTypeEnum.selectItem]: [
        MarketingEventVariableTypeEnum.productCategory,
        MarketingEventVariableTypeEnum.items
    ],
    [MarketingEventTypeEnum.viewCart]: [
        MarketingEventVariableTypeEnum.currency,
        MarketingEventVariableTypeEnum.value,
        MarketingEventVariableTypeEnum.items
    ],
    [MarketingEventTypeEnum.addToWishlist]: [
        MarketingEventVariableTypeEnum.currency,
        MarketingEventVariableTypeEnum.value,
        MarketingEventVariableTypeEnum.marketingProductId,
        MarketingEventVariableTypeEnum.productName,
        MarketingEventVariableTypeEnum.productPrice,
        MarketingEventVariableTypeEnum.quantity
    ],
    [MarketingEventTypeEnum.addShippingInfo]: [
        MarketingEventVariableTypeEnum.currency,
        MarketingEventVariableTypeEnum.value,
        MarketingEventVariableTypeEnum.shippingTier,
        MarketingEventVariableTypeEnum.items
    ],
    [MarketingEventTypeEnum.refund]: [
        MarketingEventVariableTypeEnum.transactionId,
        MarketingEventVariableTypeEnum.currency,
        MarketingEventVariableTypeEnum.value,
        MarketingEventVariableTypeEnum.items
    ],
    [MarketingEventTypeEnum.addToCompare]: [
        MarketingEventVariableTypeEnum.currency,
        MarketingEventVariableTypeEnum.value,
        MarketingEventVariableTypeEnum.marketingProductId,
        MarketingEventVariableTypeEnum.productName,
        MarketingEventVariableTypeEnum.productPrice,
        MarketingEventVariableTypeEnum.quantity
    ]
};


/**
 * Валидирует dynamicData для заданного eventTypeId
 * @param {number} eventTypeId - Идентификатор типа события
 * @param {Object} dynamicData - Объект данных события
 * @returns {boolean} - true, если данные валидны, иначе выбрасывает исключение
 */
export function validateDynamicData(eventTypeId, dynamicData) {
    const allowedVariables = MarketingEventAllowedVariables[eventTypeId];
    if (!allowedVariables) {
        throw new Error(`Неизвестный eventTypeId: ${eventTypeId}`);
    }

    // так динамк дата не обзятелен, если его нет то пропускаем проверку
    if (!dynamicData) {
        return true;
    }

    for (const key of Object.keys(dynamicData)) {
        const numericKey = parseInt(key, 10);

        if (isNaN(numericKey)) {
            let msg = `Ключ "${key}" в dynamicData не является числом`;
            //throw new Error(msg);
            console.error(msg);
            return false;
        }

        if (!allowedVariables.includes(numericKey)) {
            const allowedNames = Object.entries(MarketingEventVariableTypeEnum)
                .filter(([name, id]) => allowedVariables.includes(id))
                .map(([name]) => name);

            const actualName = MarketingEventVariableNameById[numericKey] || `[ID ${numericKey}]`;
            let msg =    `Недопустимый параметр "${actualName}" (ID ${numericKey}) для события с eventTypeId "${eventTypeId}". Разрешены: ${allowedNames.join(', ')}`
            console.error(msg);
            // throw new Error(msg);
        }
    }

    return true;
}